import React from 'react'
import "../styles/home.css";
import Services from './Services';
import About from './About';
export default function Home() {
  return (
    <header>
      <About/>
     <Services/>
    </header>
  )
}
